import TelegramComments from "@/modules/comments/pages/comments/TelegramComments"
import SiteComments from "@/modules/comments/pages/comments/SiteComments"
import PromopushkaComments from "@/modules/comments/pages/comments/PromopushkaComments"
import authMiddleware from "@/plugins/router/middlewares/auth"

export default [
    {
        path: "/telegram-comments",
        name: "TelegramComment",
        component: TelegramComments,
        meta: {
            middleware: authMiddleware,
        },
    },
    {
        path: "/site-comments",
        name: "SiteComment",
        component: SiteComments,
        meta: {
            middleware: authMiddleware,
        },
    },
    {
        path: "/promopushka-comments",
        name: "PromopushkaComment",
        component: PromopushkaComments,
        meta: {
            middleware: authMiddleware,
        },
    },
]
